import { createManagerUpdate } from '@module/helpers/centrifuge/messageUpdates';
import type { ParsedPersonalMessage } from '@module/types/centrifuge/messageTypes';
import {
  isPersonalManagerOnOffMessage,
  type PersonalManagerOnOffMessage,
} from '@module/types/centrifuge/personalMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class PersonalManagerHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<PersonalManagerOnOffMessage>) {}

  canHandle(payload: ParsedPersonalMessage): boolean {
    return isPersonalManagerOnOffMessage(payload);
  }

  handle(payload: PersonalManagerOnOffMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setPlayInfo(createManagerUpdate(payload, context.playInfo));
  }
}
